import { ElementType } from 'react'
import { Button, Modal as BootstrapModal } from 'react-bootstrap'
import { CgCloseO } from 'react-icons/cg'
import classnames from 'classnames'
import styles from './Modal.module.scss'

export interface ModalProps {
  show: boolean
  title: string
  body: JSX.Element
  footer?: JSX.Element
  onCloseButtonClick: () => void
  showClose?: boolean
}

export interface BootstrapModalProps {
  dialogAs?: ElementType
  additionalModalClassNames?: string
  additionalTitleClassNames?: string
}

const defaultProps = {
  footer: undefined,
  showClose: true,
}

const Modal = ({
  show,
  title,
  body,
  footer,
  onCloseButtonClick,
  dialogAs,
  additionalModalClassNames,
  additionalTitleClassNames,
  showClose,
}: ModalProps & BootstrapModalProps): JSX.Element => (
  <BootstrapModal
    show={show}
    onHide={onCloseButtonClick}
    className={classnames(styles.modal, additionalModalClassNames)}
    centered
    dialogAs={dialogAs}
    scrollable
    backdropClassName={styles.backdrop}
  >
    <BootstrapModal.Header className={styles.modalHeader}>
      <BootstrapModal.Title
        className={classnames(styles.modalTitle, additionalTitleClassNames)}
      >
        {title}
      </BootstrapModal.Title>
      {showClose && (
        <Button
          variant="none"
          className={styles.modalClose}
          onClick={onCloseButtonClick}
        >
          <CgCloseO />
        </Button>
      )}
    </BootstrapModal.Header>
    <BootstrapModal.Body className={styles.modalBody}>
      {body}
    </BootstrapModal.Body>
    {footer && (
      <BootstrapModal.Footer className={styles.modalFooter}>
        {footer}
      </BootstrapModal.Footer>
    )}
  </BootstrapModal>
)

Modal.defaultProps = defaultProps
export default Modal
